// /frontend/src/components/common/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  text = 'Loading...', 
  className = '',
  showText = true 
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12', 
    large: 'h-16 w-16',
    xl: 'h-20 w-20'
  };

  const textSizeClasses = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
    xl: 'text-xl'
  };

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div 
        className={`animate-spin rounded-full border-t-2 border-b-2 border-teal-600 ${sizeClasses[size]}`}
        aria-label="Loading"
      ></div>
      {showText && text && (
        <p className={`mt-4 text-gray-600 ${textSizeClasses[size]} font-medium`}>
          {text}
        </p>
      )}
    </div>
  );
};

// Alternative inline loading spinner for buttons
export const InlineSpinner = ({ size = 'small', className = '' }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-5 w-5',
    large: 'h-6 w-6'
  };

  return (
    <div 
      className={`animate-spin rounded-full border-t-2 border-b-2 border-current ${sizeClasses[size]} ${className}`}
      aria-label="Loading"
    ></div>
  );
};

export default LoadingSpinner;